import React from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';
import Navbar from './Navbar';
import Footer from './Footer';

import b1 from '../assets/b1.webp'; import b2 from '../assets/b2.webp'; import b3 from '../assets/b3.webp';
import b4 from '../assets/b4.webp'; import b5 from '../assets/b5.webp'; import b6 from '../assets/b6.webp';
import b7 from '../assets/b7.webp'; import b8 from '../assets/b8.webp'; import b9 from '../assets/b9.webp';
import b10 from '../assets/b10.webp'; import b11 from '../assets/b11.webp';
import a1 from '../assets/a1.webp'; import a2 from '../assets/a2.webp'; import a3 from '../assets/a3.webp';
import a4 from '../assets/a4.webp'; import a5 from '../assets/a5.webp'; import a6 from '../assets/a6.webp';
import a7 from '../assets/a7.webp'; import a8 from '../assets/a8.webp'; import a9 from '../assets/a9.webp';
import a10 from '../assets/a10.webp'; import a11 from '../assets/a11.webp';

const portfolioItems = [
    { before: b1, after: a1 }, { before: b2, after: a2 }, { before: b3, after: a3 },
    { before: b4, after: a4 }, { before: b5, after: a5 }, { before: b6, after: a6 },
    { before: b7, after: a7 }, { before: b8, after: a8 }, { before: b9, after: a9 },
    { before: b10, after: a10 }, { before: b11, after: a11 },
];

const Portfolio = () => {
    return (
        <div className="portfolio-page">
            <Navbar />

            <section className="portfolio-hero">
                <div className="portfolio-hero-content">
                    <h1 className="portfolio-heading">Ergebnisse, die für sich sprechen</h1>
                    <p className="portfolio-subtitle">Sehen Sie, wie wir vernachlässigte Gärten in gepflegte Wohlfühloasen verwandeln</p>
                </div>
            </section>

            <section className="portfolio-gallery">
                <div className="portfolio-container">
                    {portfolioItems.map((item, index) => (
                        <div key={index} className="portfolio-item">
                            <div className="portfolio-split">
                                <div className="portfolio-half portfolio-before">
                                    <div className="portfolio-image" style={{ backgroundImage: `url(${item.before})` }}>
                                        <div className="portfolio-label">Vorher</div>
                                    </div>
                                </div>
                                <div className="portfolio-half portfolio-after">
                                    <div className="portfolio-image" style={{ backgroundImage: `url(${item.after})` }}>
                                        <div className="portfolio-label">Nachher</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="portfolio-cta">
                <div className="cta-content">
                    <h2>Möchten Sie so eine Verwandlung?</h2>
                    <p>Kontaktieren Sie uns – gemeinsam machen wir Ihren Garten zu einem Ort, an dem Sie sich rundum wohlfühlen.</p>
                    <Link to="/contact" className="cta-button-main">Jetzt Kontakt aufnehmen</Link>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Portfolio;
